import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';

interface IProps {
  immediate?: boolean;
  children: React.ReactElement;
}

type PropsType = RouteComponentProps & IProps;

const ScrollToTop = (props: PropsType) => {
  const { immediate } = props;
  useEffect(() => {
    const timeOut = immediate === true ? 0 : 300;
    setTimeout(() => window.scrollTo(0, 0), timeOut);
  }, [immediate]);

  return props.children;
};

export default withRouter(ScrollToTop);
